<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    vaidate: v => ['primary', 'secondary', 'tertiary'].includes(v)
  },
  value: { type: [String, Number], default: undefined }
})

const shouldRender = computed(() => {
  return props.value
})

const className = computed(() => {
  if (props.variant === 'primary') return 'notification-count--emergency'
  if (props.variant === 'tertiary')
    return 'notification-count--privateUnreadMessages'
  return 'notification-count--unreadMessages'
})
</script>

<template>
  <li v-if="shouldRender" class="notification-count" :class="[className]">
    {{ value }}
  </li>
</template>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.notification-count {
  @extend %caption;
  font-weight: 800;
  top: 0;
  border-radius: var(--gl-border-radius-md);
  line-height: var(--gl-font-line-height-xxxs);
  display: inline-block;
  border: var(--gl-border-width-md) solid var(--gl-color-shades-white);
  min-width: 20px;
  text-align: center;
  padding: 0 var(--gl-spacing-01);

  & + & {
    margin-left: -4px;
  }

  &--emergency {
    background: var(--sys-color-surface-background-brand);
    color: var(--gl-color-shades-gray-00);
  }

  &--unreadMessages {
    background: var(--gl-color-shades-magenta-00);
    color: var(--sys-color-content-active);
  }

  &--privateUnreadMessages {
    background: var(--sys-color-surface-background-default);
    color: var(--sys-color-content-primary);
  }
}
</style>
